import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import device from './device';

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  @media ${device.maxLaptop} {
    margin-bottom: 12px;
  }
`

export default function AddFormItemLabel(props) {
  return (
    <LabelWrapper>
      {props.children}
      <span style={{ color: '#9DBC60', fontSize: 14, marginLeft: 4 }}>*</span>
    </LabelWrapper>
  );
}

AddFormItemLabel.propTypes = {
  children: PropTypes.any,
};
